/* unplugin-vue-components disabled */import script from "./StageGeneratorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StageGeneratorPage.vue?vue&type=script&setup=true&lang=js"

import "./StageGeneratorPage.vue?vue&type=style&index=0&id=3bf935de&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf935de"]])

export default __exports__